module.exports = __webpack_public_path__ + "static/media/Currículo João Pedro Fonseca.23ec9182.pdf";